/**
 * 何宽 2021.7.14
 * 根据不同的要求对数据进行过滤
 */
export default {
  filters:
  {
    formatJYLX: function(num)
    {
      switch (num)
      {
      case '0': return '求购'
      case '1': return '供应'
      }
    },
    formatGJ: function(num)
    {
      switch (num)
      {
      case 2: return '中国'
      case 3: return '印度尼西亚'
      case 4: return '马来西亚'
      case 5: return '菲律宾'
      case 6: return '新加坡'
      case 7: return '泰国'
      case 8: return '文莱'
      case 9: return '越南'
      case 10: return '老挝'
      case 11: return '缅甸'
      case 12: return '柬埔寨'
      case 13: return '其他'
      }
    },
    formatXMLB: function(num)
    {
      switch (num)
      {
      case '1': return '采矿权'
      case '2': return '探矿权'
      case '3': return '深加工'
      case '4': return '其它'
      }
    },
    formatSBLX: function(num)
    {
      switch (num)
      {
      case 70: return '地质仪器'
      case 71: return '矿山设备'
      }
    },
    formatZBLX: function(num)
    {
      switch (num)
      {
      case 65: return '宝石'
      case 66: return '玉石'
      }
    },
    formatYJLX: function(num)
    {
      switch (num)
      {
      case 75: return '捕捉剂'
      case 76: return '起泡剂'
      case 77: return '助磨剂'
      case 78: return '凝聚剂'
      case 79: return '絮凝剂'
      case 177: return '增效剂'
      case 178: return '调整剂'
      }
    },
    // 时间戳过滤器,将时间戳转换成 YYYY-MM-DD格式
    formatDate: function(value)
    {
      let date = new Date(value)
      let year = date.getFullYear()
      let month = date.getMonth() + 1 < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      return year + '-' + month + '-' + day
    },
    // 时间戳过滤器,将时间戳转换成 YYYY年MM月 格式
    formatDateYM: function(value)
    {
      let date = new Date(value)
      let year = date.getFullYear()
      let month = date.getMonth() + 1 < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)
      return year + '年' + month + '月'
    },
    // 时间戳过滤器,将时间戳转换成 HH-DD格式
    formatDateTime: function(value)
    {
      let date = new Date(value)
      let hour = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
      let minute = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
      return hour + ':' + minute
    },
    // 时间戳过滤器,将时间戳转换成 YYYY-MM-DD HH:MM:SS格式
    formatTime: function(value)
    {
      if (typeof (value) === 'undefined')
        return ''
      else
      {
        let date = new Date(parseInt(value))
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    },
    // 时间戳过滤器,将时间戳转换成 YYYY-MM-DD HH:MM格式
    formatYMDHM: function(value)
    {
      if (typeof (value) === 'undefined')
        return ''
      else
      {
        let date = new Date(parseInt(value))
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m
      }
    },
    getClassification: function(value)
    {
      switch (value)
      {
      case 5: return '勘查开发'
      case 6: return '投资贸易'
      case 7: return '重要公告'
      case 8: return '政策风向'
      case 9: return '综合资讯'
      case 40: return '东盟默认分类'
      case 1: return '咨询服务'
      case 2: return '法律服务'
      case 0: return ''
      }
    },
    getComments: function(value)
    {
      switch (value)
      {
      case 1: return '已回复'
      case 2: return '未回复'
      }
    },
    getKyxmType: function(value)
    {
      switch (value)
      {
      case '1': return '采矿权'
      case '2': return '探矿权'
      case '3': return '深加工'
      case '4': return '其它'
      }
    },
    typeData: function(num)
    {
      switch (num)
      {
      case 0 : return '会议'
      case 1 : return '展会'
      }
    },
    examine_datas: function(num)
    {
      switch (num)
      {
      case 0 : return '待审核'
      case 1 : return '通过'
      case 2 : return '不通过'
      }
    }
  }
}





// WEBPACK FOOTER //
// ./src/plugins/app/method/filter.js